<template>
  <div
    :class="getClass()"
    class="form-group form-group--file"
  >
    <div class="row">
      <div :class="`col-sm-${component.size}`">
        <!-- Label -->
        <label>{{ component.label }}
          <span
            v-if="isRequired()"
            class="required"
          >*</span>
        </label>

        <!-- Field -->
        <div
            class="dropzone"
            v-if="component.data"
        >
          <input
            v-model="component.data.currentValue"
            v-validate="setRules()"
            :data-vv-name="component.key"
            :name="component.key"
            class="form-control"
            type="hidden"/>

          <button
            :id="`file-input-${component.key}`"
            :disabled="disabledHandler()"
            class="btn btn-primary btn-sm"
            type="button"
          >Selecionar arquivos...
          </button>

          <div
            v-show="dropzone.files.length"
            :id="`dropzone-${component.key}`"
            class="container-fluid dropzone-table"
          >
            <div class="row thead">
              <div class="col-6 col-md-4">Nome do Arquivo</div>
              <div class="hidden-xs col-md-1">Tamanho</div>
              <div class="col-2 col-md-1">Status</div>
              <div class="col-3 col-md-5">Progresso</div>
              <div class="col-1"></div>
            </div>
          </div>
        </div>

        <!-- Mensagem de erro -->
        <span class="help-block help-block--bottom" v-if="errors.has(component.key)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">
            <g transform="translate(-252 -635)">
              <rect class="cls-1" width="14" height="14" transform="translate(252 635)"/>
              <path class="cls-2"
                    d="M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z"
                    transform="translate(251 634)"/>
            </g>
          </svg>
          {{ errors.first(component.key) }}
        </span>

        <!-- Descrição -->
        <span class="help-block help-block--bottom" v-if="!errors.has(component.key) && component.description">{{ component.description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'

import api from '@/api/form'
import { mapState } from 'vuex'

import Dropzone from 'dropzone'

// Lodash
// A modern JavaScript utility library delivering modularity, performance, & extras.
// https://github.com/lodash/lodash
import { cloneDeep } from 'lodash'

Dropzone.autoDiscover = false

export default {
  mixins: [component],
  props: ['component'],
  inject: ['$validator'],
  name: 'component-file',
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false,
      dropzone: {
        files: []
      }
    }
  },
  computed: {
    // The mapState Helper
    // https://vuex.vuejs.org/guide/state.html#the-mapstate-helper
    ...mapState({
      clientKey: state => state.config.clientKey,
      idForm: state => state.config.idForm,
      formData: state => state.formData,
      formBindData: state => state.formBindData,
      components: state => state.form.components,
      errorMessages: state => state.form.errorMessages,
      json: state => state.config.json,
      variables: state => state.config.variables
    })
  },
  methods: {
    onAccept: function (file, done) {
      this.$validator.errors.remove(this.component.key)
      if (file.size < 1) {
        this.dropzone.removeFile(file)
        this.$validator.errors.add({
          field: `${this.component.key}`,
          msg: 'O tamanho do arquivo deve ser maior que 0'
        })
        return
      }
      const regex = /(?:\.([^.]+))?$/
      const extension = regex.exec(file.upload.filename)[1]
      const fileKey = `${file.upload.uuid}.${extension}`
      const params = {
        'fileKey': fileKey,
        'fileMimeType': file.type,
        'type': 'AWS'
      }

      api.signedUrl(this.clientKey, params, this.idForm || null)
        .then(payload => {
          if (payload.data.status) {
            file.uploadURL = payload.data.data
            file.upload.filename = fileKey

            done()
            // Manually process each file
            setTimeout(() => this.dropzone.processFile(file))
          } else {
            done('Failed to get an S3 signed upload URL')
          }
        })
        .catch(() => done('Failed to get an S3 signed upload URL...'))
    },
    onRemoveFile: function (file, done) {
      const regex = /(?:\.([^.]+))?$/
      const extension = regex.exec(file.upload.filename)[1]
      const fileKey = `${file.upload.uuid}.${extension}`
      const params = {
        'fileKey': fileKey,
        'fileMimeType': file.type,
        'type': 'AWS'
      }

      let removeApi

      if (this.formData) {
        removeApi = api.removeFile
      } else {
        removeApi = api.removeTempFile
      }

      removeApi(this.clientKey ? this.clientKey : this.clientKeyStorage, params, this.idForm || null)
    },
    template: function () {
      return `<div class="row tbody">
        <div class="col-6 col-md-4 url">
          <a style="overflow-wrap: anywhere;" href="" target="_blank" data-dz-name></a>
          <span class="data-dz-name"></span>
        </div>
        <div class="hidden-xs col-md-1" data-dz-size></div>
        <div class="col-2 col-md-1">
          <div class="dz-success-mark hidden"><span>✔</span></div>
          <div class="dz-error-mark hidden"><span>✘</span></div>
        </div>
        <div class="col-3 col-md-5">
          <div class="progress">
            <div class="progress-bar progress-bar-success" data-dz-uploadprogress></div>
          </div>
          <span dz-error-message class="help-block help-block--file">
            <span data-dz-errormessage></span>
          </span>
        </div>
        <div class="col-1">
          <span data-dz-remove class="glyphicon glyphicon-trash pull-right remove"></span>
        </div>
      </div>`
    },
    async checkFileSize (file) {
      console.log(file)
      const params = {
        'fileKey': (file.upload || {}).filename
      }
      const res = await api.getFileSize(this.clientKey, params, this.idForm || null)

      return res.status && file.size === res.data.data.fileSize
    },
    handlerError (file) {
      file.previewElement.querySelector('.dz-success-mark').remove()
      file.previewElement.querySelector('.dz-error-mark').classList.remove('hidden')

      var active = file.previewElement.querySelector('.progress')
      active.remove()

      var remove = file.previewElement.querySelector('.remove')
      remove.remove()
    }
  },
  created () {
    this.$set(this.component, 'data', {})
    this.$set(this.component.data, 'defaultValue', [])
    this.setValue()
  },
  mounted () {
    const acceptedFiles = this.component.validate.filePattern ? this.component.validate.filePattern.join(',') : '*'
    let self = this

    this.dropzone = new Dropzone(`#dropzone-${this.component.key}`, {
      // The URL will be changed for each new file being processing
      url: '/',

      // Since we're going to do a `PUT` upload to S3 directly
      method: 'put',

      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      uploadMultiple: false,

      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: '',

      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,

      acceptedFiles: acceptedFiles,
      paramName: 'file',
      previewTemplate: this.template(),
      clickable: `#file-input-${this.component.key}`,
      dictDefaultMessage: `Soltar arquivos aqui para upload.`,
      dictFallbackMessage: `Seu navegador não suporta arrastar e soltar arquivos.`,
      dictFallbackText: `Por favor, use o formulário de fallback abaixo para enviar seus arquivos como nos velhos tempos.`,
      dictFileTooBig: this.$validator.dictionary.container.pt_BR.messages.fileMaxSize(null, [this.component.validate.fileMaxSize]),
      dictInvalidFileType: this.$validator.dictionary.container.pt_BR.messages.filePattern(null, [this.component.validate.filePattern]),
      dictResponseError: `O servidor respondeu com o código {{statusCode}}.`,
      dictCancelUpload: `Cancelar upload`,
      dictCancelUploadConfirmation: `Tem certeza de que deseja cancelar este upload?`,
      dictRemoveFile: `Remover arquivo`,
      dictMaxFilesExceeded: this.$validator.dictionary.container.pt_BR.messages.fileMax(null, [this.component.validate.fileMax]),
      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending (file, xhr) {
        let _send = xhr.send
        xhr.send = () => {
          _send.call(xhr, file)
        }
      },
      // Here we request a signed upload URL when a file being accepted
      accept: (file, done) => this.onAccept(file, done),
      init () {
        /* eslint no-undef: "error" */
        const files = cloneDeep(self.component.data.currentValue)

        files.map(file => {
          file.accepted = true

          this.emit('addedfile', file)
          this.emit('uploadprogress', file, 100)
          this.emit('success', file)

          this.emit('complete', file)

          this.files.push(file)

          file.previewElement.querySelector('a').href = file.url
          file.previewElement.querySelector('.dz-error-mark').remove()
          file.previewElement.querySelector('.dz-success-mark').classList.remove('hidden')
        })
      }
    })

    if (this.component.validate.fileMax) {
      this.dropzone.options['maxFiles'] = this.component.validate.fileMax
    }

    if (this.component.validate.fileMaxSize) {
      this.dropzone.options['maxFilesize'] = this.component.validate.fileMaxSize
    }

    this.dropzone.on('addedfile', (file) => {
      file.previewElement.querySelector('a').remove()
      file.previewElement.querySelector('.data-dz-name').innerHTML = file.name
    })

    this.dropzone.on('removedfile', (file) => {
      this.onRemoveFile(file)
      const files = this.dropzone.getAcceptedFiles()
      this.component.data.currentValue = files.reduce((a, c) => {
        const params = {
          name: c.name,
          nameKey: c.upload ? c.upload.filename : c.nameKey,
          size: c.size
        }
        a.push(params)
        return a
      }, [])
    })

    this.dropzone.on('success', async (file) => {
      const isFileSizeValid = await this.checkFileSize(file)
      if (!isFileSizeValid) {
        return this.handlerError(file)
      }
      file.previewElement.querySelector('.dz-error-mark').remove()
      file.previewElement.querySelector('.dz-success-mark').classList.remove('hidden')

      const files = this.dropzone.getAcceptedFiles()
      this.component.data.currentValue = files.reduce((a, c) => {
        const params = {
          name: c.name,
          nameKey: c.upload ? c.upload.filename : c.nameKey,
          size: c.size
        }
        a.push(params)
        return a
      }, [])
    })

    this.dropzone.on('error', (file, message, xhr) => {
      this.handlerError(file)
    })

    this.dropzone.on('maxfilesexceeded', (file) => {
      var active = file.previewElement.querySelector('.progress-bar')
      if (active) {
        active.classList.remove('progress-bar-success')
        active.classList.add('progress-bar-danger')
      }
    })

    // Set signed upload URL for each file
    this.dropzone.on('processing', (file) => {
      this.dropzone.options.url = file.uploadURL
    })

    this.dropzone.on('drop', (event) => event.preventDefault())
    this.dropzone.on('dragstart', (event) => event.preventDefault())
    this.dropzone.on('dragend', (event) => event.preventDefault())
    this.dropzone.on('dragenter', (event) => event.preventDefault())
    this.dropzone.on('dragover', (event) => event.preventDefault())
    this.dropzone.on('dragleave', (event) => event.preventDefault())
  }
}
</script>

<style>
.remove {
  color: red;
}
.remove:hover {
  cursor: pointer;
}
</style>
